import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/r1/a/_Whimstay-travel-agent/src/app/detail/[...slug]/src/header/HeaderSearchPill.tsx");
